import { render, staticRenderFns } from "./captioned-field.vue?vue&type=template&id=714ad9fb"
import script from "./captioned-field.vue?vue&type=script&lang=ts"
export * from "./captioned-field.vue?vue&type=script&lang=ts"
import style0 from "./captioned-field.vue?vue&type=style&index=0&id=714ad9fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports